import React, { useState } from "react";
import { X, KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function ChangePasswordModal({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const reset = () => {
    setCurrent("");
    setNext("");
    setConfirm("");
  };

  const close = () => {
    reset();
    onClose();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("Parola noua trebuie sa aiba minim 8 caractere.");
      return;
    }
    if (next !== confirm) {
      toast.error("Parola noua si confirmarea nu coincid.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/api/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      toast.success("Parola a fost schimbata.");
      close();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Schimbarea parolei a esuat");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="change-password-overlay"
      className="fixed inset-0 z-50 grid place-items-center bg-slate-900/40 px-4"
      onClick={close}
    >
      <form
        data-testid="change-password-form"
        onClick={(e) => e.stopPropagation()}
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-6 shadow-xl"
      >
        <div className="mb-5 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="grid h-8 w-8 place-items-center rounded bg-accent-500/15 text-accent-600">
              <KeyRound size={16} />
            </div>
            <h3 className="text-base font-semibold text-slate-900">Schimba parola</h3>
          </div>
          <button
            type="button"
            data-testid="change-password-close-btn"
            onClick={close}
            className="rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
          >
            <X size={18} />
          </button>
        </div>

        <label className="mb-1 block text-sm text-slate-600" htmlFor="cp-current">Parola curenta</label>
        <input
          id="cp-current"
          data-testid="change-password-current-input"
          type="password"
          required
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          className="mb-4 w-full rounded border border-slate-200 bg-slate-50 px-3 py-2 text-slate-900 outline-none focus:border-accent-500"
        />

        <label className="mb-1 block text-sm text-slate-600" htmlFor="cp-new">Parola noua (minim 8 caractere)</label>
        <input
          id="cp-new"
          data-testid="change-password-new-input"
          type="password"
          required
          autoComplete="new-password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          className="mb-4 w-full rounded border border-slate-200 bg-slate-50 px-3 py-2 text-slate-900 outline-none focus:border-accent-500"
        />

        <label className="mb-1 block text-sm text-slate-600" htmlFor="cp-confirm">Confirma parola noua</label>
        <input
          id="cp-confirm"
          data-testid="change-password-confirm-input"
          type="password"
          required
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="mb-6 w-full rounded border border-slate-200 bg-slate-50 px-3 py-2 text-slate-900 outline-none focus:border-accent-500"
        />

        <div className="flex gap-2">
          <button
            type="submit"
            data-testid="change-password-submit-btn"
            disabled={submitting}
            className="inline-flex flex-1 items-center justify-center gap-2 rounded bg-accent-500 px-4 py-2 font-semibold text-ink-950 hover:bg-accent-600 disabled:opacity-60"
          >
            {submitting ? <Loader2 className="animate-spin" size={16} /> : <KeyRound size={16} />} Salveaza
          </button>
          <button
            type="button"
            data-testid="change-password-cancel-btn"
            onClick={close}
            className="rounded border border-slate-300 px-4 py-2 text-slate-700 hover:bg-slate-100"
          >
            Anuleaza
          </button>
        </div>
      </form>
    </div>
  );
}
